// extracted by mini-css-extract-plugin
export default {"loadingShell":"PunchupShowPerformanceSection_loadingShell__iLL9i punchupAnalyticsLoadingShell","kpiGrid":"PunchupShowPerformanceSection_kpiGrid__cVCTk"};